import React from "react";
import { Link } from "gatsby"
import logo_img from '../../../content/assets/Karen_Thomson_SFR_logo.jpeg';
import './headerStyle.css';

const Header = ({ fontColor, logo }) => {
	return (
        <header className='ui-header'>
            <div className='ui-container ui-header-container'>
                {   logo ? (
                        <Link to="/">
                            <img className='ui-logo' src={logo || logo_img} />
                        </Link>) : <div className='ui-logo'></div>
                }
                <nav className='navbar-right' style={{ color: fontColor }}>
                    <Link className='navbar-item' to='/' style={{ color: fontColor }}>Sign Up</Link>
                    <Link className='navbar-item' to='/help-form' style={{ color: fontColor }}>Contact Us</Link>
                </nav>
            </div>
        </header>
	)
}

export default Header;